export const colorPageFaqs = [
  // {
  //     questionText: "What types of coloring pages are available?",
  //     answerText:
  //         "We offer a wide variety of coloring pages, including themes like animals, nature, fantasy, holidays, and more.",
  // },
  // {
  //     questionText: "Are the coloring pages free to download?",
  //     answerText:
  //         "We offer a wide variety of coloring pages, including themes like animals, nature, fantasy, holidays, and more.",
  // },
  // {
  //     questionText: "How do I download the coloring pages?",
  //     answerText:
  //         "We offer a wide variety of coloring pages, including themes like animals, nature, fantasy, holidays, and more.",
  // },
  {
    questionText: 'What paper should I use for coloring pages?',
    answerText:
      'You may use any paper for coloring pages for kids since it is only used for keeping your little one engaged. The regular copier paper is good enough.',
  },
  {
    questionText: 'Can coloring pages be preserved?',
    answerText:
      "Yes, you can preserve the coloring pages for kids. You may laminate your child's coloring pages or get them framed and preserve these memories.",
  },
  {
    questionText: 'Are the coloring pages free to download?',
    answerText:
      'Yes, all our coloring pages are free to download and print for personal use.',
  },
  {
    questionText: 'What materials do I need for coloring?',
    answerText:
      'You can use crayons, colored pencils, markers, or any other coloring tools your child prefers.',
  },
];

export const colorPagesData = {
  'princess-peach-coloring-pages': {
    images: [
      {
        url: 'https://images.myloapp.in/NestJsUploads/1717759241762-MicrosoftTeams-image-(52).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1717759241762-MicrosoftTeams-image-(52).png',
        name: 'Princess peach coloring pages sample',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1717759241762-MicrosoftTeams-image-(51).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1717759241762-MicrosoftTeams-image-(51).png',
        name: 'Princess peach coloring pages image 1',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1717759241762-MicrosoftTeams-image-(53).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1717759241762-MicrosoftTeams-image-(53).png',
        name: 'Princess peach coloring pages image 2',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1717759241761-MicrosoftTeams-image-(54).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1717759241761-MicrosoftTeams-image-(54).png',
        name: 'Princess peach coloring pages image 3',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1717759241760-MicrosoftTeams-image-(55).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1717759241760-MicrosoftTeams-image-(55).png',
        name: 'Princess peach coloring pages image 4',
      },
    ],
    breadcrumb: 'PRINCESS PEACH COLORING PAGES',
    batchUrl:
      'https://images.myloapp.in/color_images/Princess%20Peach%20Coloring%20Pages.pdf',
    pageTitle: 'Princess Peach Coloring Pages | Printable Coloring Sheets',
    metaData: {
      title: 'Princess peach coloring page | MyloFamily',
      description:
        'Join Princess Peach on a royal adventure with these enchanting coloring pages. Perfect for kids, these illustrations feature the beloved Mario character in various poses and settings, encouraging creativity and imagination.',
    },
    content:
      'Get ready for a royally sweet adventure with Princess Peach coloring pages. These adorable illustrations feature the beloved Mario character in her iconic costume and as Super Princess Peach, perfect for kids to color and create their own magical kingdom.',
  },

  'barbie-coloring-pages': {
    images: [
      {
        url: 'https://images.myloapp.in/NestJsUploads/1717759512874-MicrosoftTeams-image-(60).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1717759512874-MicrosoftTeams-image-(60).png',
        name: 'Barbie coloring pages sample',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1717759512875-MicrosoftTeams-image-(56).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1717759512875-MicrosoftTeams-image-(56).png',
        name: 'Barbie dress coloring page',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1717759512875-MicrosoftTeams-image-(57).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1717759512875-MicrosoftTeams-image-(57).png',
        name: 'Barbie Coloring Page',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1717759512875-MicrosoftTeams-image-(58).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1717759512875-MicrosoftTeams-image-(58).png',
        name: 'Barbie halloween costume coloring pages',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1717759512875-MicrosoftTeams-image-(59).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1717759512875-MicrosoftTeams-image-(59).png',
        name: 'Barbie cake coloring page',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1717760241071-MicrosoftTeams-image-(61).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1717760241071-MicrosoftTeams-image-(61).png',
        name: 'Cowgirl Barbie coloring page',
      },
    ],
    breadcrumb: 'BARBIE COLORING PAGES',
    batchUrl:
      'https://images.myloapp.in/color_images/Barbie%20Coloring%20Pages.pdf',
    pageTitle: 'Barbie Coloring Pages | Printable Coloring Sheets',
    metaData: {
      title: 'Barbie coloring page | MyloFamily',
      description:
        'Get ready for a fashionable & fun adventure with Barbie coloring pages. These vibrant illustrations feature the iconic doll in various outfits and settings will make your child imagine themselves in barbie world!',
    },
    content:
      "Indulge in a world of fashion and creativity with Barbie coloring pages. These vibrant illustrations feature the iconic doll in various outfits and settings, perfect for kids to express their imagination and style. From Barbie's signature dresses to her adorable accessories, these coloring pages offer endless opportunities for self-expression and fun.",
  },
  'sonic-coloring-pages': {
    images: [
      {
        url: 'https://images.myloapp.in/NestJsUploads/1717760445210-MicrosoftTeams-image-(64).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1717760445210-MicrosoftTeams-image-(64).png',
        name: 'Sonic coloring pages sample',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1717760445210-MicrosoftTeams-image-(62).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1717760445210-MicrosoftTeams-image-(62).png',
        name: 'Sonic the hedgehodg coloring pages',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1717760445210-MicrosoftTeams-image-(63).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1717760445210-MicrosoftTeams-image-(63).png',
        name: 'Sonic ice cream menu coloring pages',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1717760445210-MicrosoftTeams-image-(65).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1717760445210-MicrosoftTeams-image-(65).png',
        name: 'Sonic coloring page',
      },
    ],
    breadcrumb: 'SONIC COLORING PAGES',
    batchUrl:
      'https://images.myloapp.in/color_images/Sonic%20Coloring%20Pages.pdf',
    pageTitle: 'Sonic Coloring Pages | Printable Coloring Sheets',
    metaData: {
      title: 'Sonic Coloring Pages | MyloFamily',
      description:
        'Embark on a speedy adventure with Sonic coloring pages! Featuring the beloved video game character, these pages offer kids the chance to color in their favorite hedgehog and his friends.',
    },
    content:
      "Get ready to speed into fun with Sonic coloring pages These high-energy illustrations feature the beloved video game character in various poses and settings, perfect for kids to express their creativity and imagination. From Sonic's iconic blue spikes to his speedy adventures, these coloring pages offer endless opportunities for self-expression and excitement. ",
  },
  'rainbow-friends-coloring-pages': {
    images: [
      {
        url: 'https://images.myloapp.in/NestJsUploads/1718000115607-MicrosoftTeams-image-(66).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1718000115607-MicrosoftTeams-image-(66).png',
        name: 'Rainbow friends coloring page sample',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1718011736529-MicrosoftTeams-image-(70).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1718011736529-MicrosoftTeams-image-(70).png',
        name: 'Rainbow friends coloring pages image 1',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1718000115603-MicrosoftTeams-image-(67).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1718000115603-MicrosoftTeams-image-(67).png',
        name: 'Rainbow friends coloring pages image 2',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1718011736529-MicrosoftTeams-image-(71).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1718011736529-MicrosoftTeams-image-(71).png',
        name: 'Rainbow friends coloring pages image 3',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1718012058330-MicrosoftTeams-image-(73).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1718012058330-MicrosoftTeams-image-(73).png',
        name: 'Rainbow friends coloring pages image 4',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1718011736525-MicrosoftTeams-image-(72).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1718011736525-MicrosoftTeams-image-(72).png',
        name: 'Cyan Rainbow friends coloring pages image 5',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1718012058330-MicrosoftTeams-image-(74).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1718012058330-MicrosoftTeams-image-(74).png',
        name: 'Rainbow friends characters coloring pages image 6',
      },
    ],
    breadcrumb: 'RAINBOW FRIENDS COLORING PAGES',
    batchUrl:
      'https://images.myloapp.in/color_images/Rainbow%20Friends%20Coloring%20Pages.pdf',
    pageTitle: 'Rainbow Friends Coloring Pages | Printable Coloring Sheets',
    metaData: {
      title: 'Rainbow Friends Coloring Pages for Kids | MyloFamily',
      description:
        'Unleash the colors of friendship with Rainbow Friends coloring pages. These vibrant illustrations feature lovable characters, perfect for kids to express their creativity and kepp them busy.',
    },
    content:
      'Embark on a colorful adventure with Rainbow Friends coloring pages! Featuring the beloved Blue and Green Rainbow Friends, these delightful designs invite kids to bring their favorite characters to life. With intricate patterns and whimsical details, these coloring pages offer endless opportunities for creativity and self-expression. Dive into the world of Rainbow Friends and let your imagination soar with every stroke of the crayon.',
  },
  'squishmallow-coloring-pages': {
    images: [
      {
        url: 'https://images.myloapp.in/NestJsUploads/1718347096056-MicrosoftTeams-image-(51).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1718347096056-MicrosoftTeams-image-(51).png',
        name: 'Squishmallow pet bed sample',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1718009962078-MicrosoftTeams-image-(68).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1718009962078-MicrosoftTeams-image-(68).png',
        name: 'Gengar Squishmallow coloring pages',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1718009962081-MicrosoftTeams-image-(69)-(1).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1718009962081-MicrosoftTeams-image-(69)-(1).png',
        name: 'Stitch Squishmallow coloring pages',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1718009962081-MicrosoftTeams-image-(69)-(2).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1718009962081-MicrosoftTeams-image-(69)-(2).png',
        name: 'Snorlax Squishmallow coloring pages',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1718009962082-MicrosoftTeams-image-(69).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1718009962082-MicrosoftTeams-image-(69).png',
        name: 'Togepi Squishmallow coloring pages',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1718009962082-MicrosoftTeams-image-(69)-(3).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1718009962082-MicrosoftTeams-image-(69)-(3).png',
        name: 'Squishmallow coloring page',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1718010059887-MicrosoftTeams-image-(69)-(4).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1718010059887-MicrosoftTeams-image-(69)-(4).png',
        name: 'Squishmallow Pet bed coloring pages',
      },
      {
        url: 'https://images.myloapp.in/NestJsUploads/1718010059888-MicrosoftTeams-image-(69)-(5).webp',
        downloadUrl:
          'https://images.myloapp.in/NestJsUploads/1718010059888-MicrosoftTeams-image-(69)-(5).png',
        name: 'Squishmallow Slippers coloring pages',
      },
    ],
    breadcrumb: 'SQUISHMALLOW FRIENDS COLORING PAGES',
    batchUrl:
      'https://images.myloapp.in/color_images/Squishmallow%20Coloring%20Pages.pdf',
    pageTitle: 'Squishmallow Coloring Pages | Printable Coloring Sheets',
    metaData: {
      title: 'Squishmallow Coloring Pages for Kids | MyloFamily',
      description:
        'Make your child discover the joy of coloring with Squishmallow coloring pages! These pages feature adorable characters providing endless fun and creativity for kids of all ages.',
    },
    content:
      'Explore the adorable world of Squishmallow coloring pages featuring beloved characters like Togepi, Snorlax, Hello Kitty, and Stitch. These delightful designs capture the charm of Squishmallow plush toys, perfect for coloring enthusiasts of all ages. Create your Squishmallow pet bed scenes or bring these lovable characters to life with vibrant colors and endless creativity! ',
  },
};

export const colorPageCategoryData = [
  {
    title: 'Squishmallow Coloring Pages',
    image:
      'https://images.myloapp.in/NestJsUploads/1717755103573-Squishmellow-Coloring-Pages.webp',

    totalCount: 8,
    key: '/coloring-pages-for-kids/squishmallow-coloring-pages',
  },
  {
    title: 'Rainbow Coloring Pages',
    image:
      'https://images.myloapp.in/NestJsUploads/1717755103570-Rainbow-Friends-Coloring-Pages.webp',

    totalCount: 8,
    key: '/coloring-pages-for-kids/rainbow-friends-coloring-pages',
  },
  {
    title: 'Sonic Coloring Pages',
    image:
      'https://images.myloapp.in/NestJsUploads/1717755103571-Sonic-The-Hedgehog-Coloring-Pages.webp',
    totalCount: 4,
    key: '/coloring-pages-for-kids/sonic-coloring-pages',
  },
  {
    title: 'Barbie Coloring Pages',
    image:
      'https://images.myloapp.in/NestJsUploads/1717755103568-Barbie-Coloring-Pages.webp',

    totalCount: 6,
    key: '/coloring-pages-for-kids/barbie-coloring-pages',
  },
  {
    title: 'Princess Peach Coloring Pages',
    image:
      'https://images.myloapp.in/NestJsUploads/1717755103569-Princess-Peach-Coloring-Pages.webp',

    totalCount: 5,
    key: '/coloring-pages-for-kids/princess-peach-coloring-pages',
  },
];

export const colorPageFootNote = `
    <h2><strong>Is coloring helpful in baby development?</strong></h2>
    <p>Coloring pages for kids are handy for your baby's development:</p>
    <ol>
    <li>
    <p>Coloring helps develop fine motor skills, hand-eye coordination, and color recognition in small children. </p>
    </li>
    <li>
    <p> Coloring helps kids to express themselves & develop imagination. This highly engaging activity is also very calming for kids. 
    </p>
    </li>
    <li>
    <p>Children who color are more patient, persistent, and focused. To assist kids get ready for preschool, it introduces basic math concepts like shapes, numbers, and counting.</p>
    </li>
    <li>
    <p>Learning can be entertaining and interesting with coloring pages that feature well-known characters.</p>
    </li>
    <li>
    <p>Lastly, kids' confidence is boosted by coloring since they feel accomplished after finishing a sheet.</p>
    </li>
    </ol>

    <h2><strong>Why are coloring pages useful for kids? </strong></h2>
    <p>Coloring pages for kids are beneficial for several reasons. They help develop fine motor skills, hand-eye coordination, and concentration in young children. Coloring allows children to express their creativity and emotions using different colors. Coloring also helps kids learn about colors, shapes, and patterns. Coloring pages can be used as educational tools to prepare children for school. Additionally, coloring is a relaxing activity that can promote mindfulness and well-being in kids. Overall, coloring pages are a fun and engaging way for children to learn and grow. </p>

    <h2><strong>Craft ideas to use Free Coloring Pages for Kids</strong></h2>
    <p>Apart from being highly engaging & useful, you can also use free coloring pages for kids to create the following crafts:</p>

    <ol>
    <li>
    <p><strong>Gift Bags:</strong> Personalize your gift bags by adding your child's coloring sheet on top of gift bags.</p>
    </li>
    <li>
    <p><strong>Puzzles:</strong> Make your child's coloring sheets into jigsaw puzzles. Just paste the coloring sheet on a piece of cardboard & make cutouts for them to assemble!</p>  
    </li>
    <li>
    <p><strong>Wrapping Paper:</strong> Kids can use coloring pages as wrapping sheets for little gifts.</p>
    </li>
    <li>
    <p><strong>Bookmarks:</strong> Kids' coloring pages can be used as bookmarks.</p>
    </li>
    <li>
    <p><strong>Wall Decoration:</strong> Decorate your walls with the coloring pages created by your little munchkin.</p>
    </li>
    </ol>
`;
